import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export type OnErrorCommandParams = {
    method: string,
    error: string
};

export class OnErrorCommand extends JsToClientCommand<OnErrorCommandParams> {
    constructor(params: OnErrorCommandParams) {
        super(ClientCommands.COMMAND_ERROR, params);
    }
}
